import { MenuItem, Drawer, AppBar, List, ListItemButton, Box, Button, IconButton } from 'components/ui';
import styled from 'styled-components';
import theme from 'theme';

export const MenuButton = styled(Button)`
  color: ${theme.palette.text.primary};
  text-transform: none;
  &:hover {
    background-color: ${theme.palette.background.default};
  }
`;

export const SideMenuDrawer = styled(Drawer)`
  &.full-width {
    > div {
      width: 100vw;
    }
  }
  > div {
    z-index: 1;
    position: fixed;
    top: 0;
    padding-top: calc(${theme.height.topMenu} - 10px);
    width: ${theme.width.sideMenu};
    border: none;
    background-color: ${theme.palette.primary.white};
    background-image: none;

    ul {
      padding-top: 0;

      a:first-child {
        margin-top: 0;
      }
    }
  }
`;

export const MenuList = styled(List)``;

export const ListMenuItem = styled(ListItemButton)`
  text-decoration: none;
  color: ${theme.palette.text.primary};
  font-size: ${theme.typography.fontSize}px;
  gap: 10px;
  margin: 9px 12px;
  justify-content: flex-start;
  border-radius: 8px;

  &.Mui-selected {
    background: none;
    color: ${theme.palette.link.menu};
    background-color: ${theme.palette.menu.selected};

    & .MuiListItemText-primary {
      font-weight: 700 !important;
    }

    & .MuiTypography-root {
      font-weight: 700 !important;
    }

    &:hover {
      background-color: ${theme.palette.background.default};
    }

    .pre {
      position: absolute;
      left: 0px;
      top: 6px;
      bottom: 6px;
      width: 3px;
      border-radius: 2px;
      background: ${theme.palette.menu.selectedSpan};
    }
  }
`;

export const StyledAppBar = styled(AppBar)`
  background-color: ${theme.palette.primary.white};
  background-image: none;
  box-shadow: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: ${theme.height.topMenu};
`;

export const TopMenuItem = styled(MenuItem)`
  text-decoration: none;
  color: ${theme.palette.primary.main};
`;

export const SidebarToggleWrapper = styled(Box)`
  position: fixed;
  bottom: 16px;
  left: ${({ $open }) => ($open ? `calc(${theme.width.sideMenu} - 20px)` : '0')};
  transition: left 225ms cubic-bezier(0.4, 0, 0.6, 1);
  z-index: 1201;
`;

export const SidebarToggleButton = styled(IconButton)`
  background-color: ${theme.palette.primary.white};
  border-radius: 0;
  &:hover {
    background-color: ${theme.palette.primary.white};
  }
`;
